(function() {
    'use strict';

    angular.module('product')
        .controller('ProductParameterOptionUpdateController', ProductParameterOptionUpdateController);

    ProductParameterOptionUpdateController.$inject = ['$uibModalInstance', 'row'];

    function ProductParameterOptionUpdateController($uibModalInstance, row) {
        var self = this;

        self.optionData = row;
        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            $uibModalInstance.close(self.optionData);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
